import React, { useEffect, useRef, useState } from "react";
import "../ProductDetail/style/gallery.css";
import Zoomimage from "../../Component/Zoomimage";
import "react-loading-skeleton/dist/skeleton.css";

const Gallery = ({
  mainimage,
  quality_name,
  design,
  shade,
  images = [],
}) => {

  const galleryImages =
    images.length > 0
      ? Object.keys(images[0])
          .filter(
            (key) =>
              key.startsWith("designshadeimage_") && images[0][key]
          )
          .sort()
          .map((key, index) => ({
            id: index + 1,
            src: images[0][key],
          }))
      : [];

  const allImages =
    galleryImages.length > 0
      ? galleryImages
      : [{ id: 1, src: mainimage }];

  const [mainImage, setMainImage] = useState(mainimage);
  const [activeThumbnail, setActiveThumbnail] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const thumbnailRef = useRef(null);
  const thumbnailsPerPage = 5; // LIMIT 6 IMAGES
  const isScrollable = allImages.length > thumbnailsPerPage;
  const thumbnailImages = [...allImages];
  if (thumbnailImages.length >= 2) {
    [thumbnailImages[0], thumbnailImages[1]] = [
      thumbnailImages[1],
      thumbnailImages[0],
    ];
  }
  
  // useEffect(() => {
  //   if (allImages.length > 0) {
  //     setMainImage(allImages[0].src);
  //     setActiveThumbnail(allImages[0].id);
  //     setStartIndex(0);
  //   }
  // }, [mainimage, images]);

  useEffect(() => {
  if (thumbnailImages.length > 0) {
    setMainImage(thumbnailImages[0].src);
    setActiveThumbnail(thumbnailImages[0].id);
  }
}, [mainimage, images]);


  const handleThumbnailClick = (src, id) => {
    setMainImage(src);
    setActiveThumbnail(id);
  };

  // UP SCROLL
  const handleUp = () => {
    if (!isScrollable) return;

    setStartIndex((prev) => Math.max(prev - 1, 0));

    thumbnailRef.current?.scrollBy({
      top: -90,
      behavior: "smooth",
    });
  };

  // DOWN SCROLL
  const handleDown = () => {
    if (!isScrollable) return;

    setStartIndex((prev) =>
      Math.min(prev + 1, allImages.length - thumbnailsPerPage)
    );

    thumbnailRef.current?.scrollBy({
      top: 90,
      behavior: "smooth",
    });
  };



  return (
    <>
      <div className="gallery-container">
        <div className="row">

          <div className="col-md-12">
            <h2 className="gallery-title text-center">
              {quality_name}
              <span style={{ color: "#ff935c" }}>
                {" "}
                {design} - {shade}
              </span>
            </h2>
          </div>

          {/* MAIN IMAGE */}
          <div className="col-md-10 col-9">
            <div className="main-image">
              <img
                src={mainImage}
                className="main-image-img"
                alt=""
                onClick={() => setShowModal(true)}
              />
              <span
                className="zoomicon"
                onClick={() => setShowModal(true)}
              >
                <i className="bi bi-zoom-in"></i>
              </span>
            </div>
          </div>

          {/* THUMBNAILS */}
          <div className="col-md-2 col-3">
            <div className="thumbnail-wrapper">

              {/* UP BUTTON */}
              <button
                className="thumb-btn up"
                onClick={handleUp}
                disabled={!isScrollable || startIndex === 0}
                style={{
                  opacity:
                    !isScrollable || startIndex === 0 ? 0.4 : 1,
                  cursor:
                    !isScrollable || startIndex === 0
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <i className="bi bi-chevron-up"></i>
              </button>

              {/* THUMBNAIL AREA */}
              <div
                className="thumbnail-container"
                ref={thumbnailRef}
                style={{
                  height: "600px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {thumbnailImages.map((img) => (
                  <img
                      key={img.id}
                      src={img.src}
                      alt=""
                      onClick={() => handleThumbnailClick(img.src, img.id)}
                      className={`thumbnail ${
                        activeThumbnail === img.id ? "active" : ""
                      }`}
                    style={{
                      height: "80px",
                      objectFit: "cover",
                      cursor: "pointer",
                      border:
                        activeThumbnail === img.id
                          ? "2px solid #ff935c"
                          : "none",
                    }}
                  />
                ))}
              </div>

              {/* DOWN BUTTON */}
              <button
                className="thumb-btn down"
                onClick={handleDown}
                disabled={
                  !isScrollable ||
                  startIndex >=
                    allImages.length - thumbnailsPerPage
                }
                style={{
                  opacity:
                    !isScrollable ||
                    startIndex >=
                      allImages.length - thumbnailsPerPage
                      ? 0.4
                      : 1,
                  cursor:
                    !isScrollable ||
                    startIndex >=
                      allImages.length - thumbnailsPerPage
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <i className="bi bi-chevron-down"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Zoomimage
        showModal={showModal}
        handleCloseModal={() => setShowModal(false)}
        modalImage={mainImage}
      />
    </>
  );
};

export default Gallery;